export class PelletizingProductInfo {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',
          materialName= ``,
          wetWeight= ``,
          dryWeight= ``,
          moisture= ``,
          productYield= ``,
          CrYield= ``,
          returnGreenPellets1= ``,
          returnGreenPellets2= ``,
          returnFilterCake= ``,
          returnFlyAsh= ``,
          returnUnderPellets= ``,
          // mineralConsumeRate= ``,          
          // ballConsumeRate= ``,
          // earthConsumeRate= ``,
          // coalConsumeRate= ``,
          // stoneConsumeRate= ``,
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift;  
      this.materialName = materialName;    
      this.wetWeight = wetWeight;
      this.dryWeight = dryWeight;
      this.moisture = moisture;
      this.productYield = productYield;
      this.CrYield = CrYield;
      this.returnGreenPellets1 = returnGreenPellets1;
      this.returnGreenPellets2 = returnGreenPellets2;
      this.returnFilterCake = returnFilterCake;
      this.returnFlyAsh = returnFlyAsh;
      this.returnUnderPellets = returnUnderPellets;
      // this.mineralConsumeRate = mineralConsumeRate;
      // this.ballConsumeRate = ballConsumeRate;
      // this.earthConsumeRate = earthConsumeRate;
      // this.coalConsumeRate = coalConsumeRate;
      // this.stoneConsumeRate = stoneConsumeRate;
    }
  }
  export function gridFields() {
    return Object.freeze([      
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },    
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },                       
        {
          key: 'materialName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        },               
        {
          key: 'wetWeight',
          label: 'lbl.prd.execution.wetWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'dryWeight',
          label: 'lbl.prd.execution.dryWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'moisture',
          label: 'lbl.prd.execution.materialMoisture',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'productYield',
          label: 'lbl.prd.execution.productYield',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CrYield',
          label: 'lbl.prd.execution.CrYield',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'returnGreenPellets1',
          label: 'lbl.prd.execution.returnGreenPellets1',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'returnGreenPellets2',
          label: 'lbl.prd.execution.returnGreenPellets2',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'returnFilterCake',
          label: 'lbl.prd.execution.returnFilterCake',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'returnFlyAsh',
          label: 'lbl.prd.execution.returnFlyAsh',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'returnUnderPellets',
          label: 'lbl.prd.execution.returnUnderPellets',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'mineralConsumeRate',
        //   label: 'lbl.prd.execution.mineralConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'ballConsumeRate',
        //   label: 'lbl.prd.execution.ballConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'earthConsumeRate',
        //   label: 'lbl.prd.execution.earthConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'coalConsumeRate',
        //   label: 'lbl.prd.execution.coalConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'stoneConsumeRate',
        //   label: 'lbl.prd.execution.stoneConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new PelletizingProductInfo()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',      
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
  };